<app-nav-bar-v2 [darkNav]="true"></app-nav-bar-v2>
<main class="aboutus-container">
  <section class="aboutus-hero-section">
    <div class="hero-img">
      <svg
        class="oct-svg"
        width="572"
        height="573"
        viewBox="0 0 572 573"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M250.028 7.76543C273.06 -1.775 298.94 -1.77501 321.972 7.76543L457.659 63.9687C480.692 73.5091 498.991 91.8085 508.531 114.841L564.735 250.528C574.275 273.56 574.275 299.44 564.735 322.472L508.531 458.159C498.991 481.192 480.692 499.491 457.659 509.031L321.972 565.235C298.94 574.775 273.06 574.775 250.028 565.235L114.341 509.031C91.3085 499.491 73.0091 481.192 63.4687 458.159L7.26543 322.472C-2.275 299.44 -2.27501 273.56 7.26543 250.528L63.4687 114.841C73.0091 91.8085 91.3085 73.5091 114.341 63.9687L250.028 7.76543Z"
          fill="#00040B"
        />
      </svg>
    </div>
    <div class="hero-title-container">
      <div class="hero-title">
        <h1>
          we help <br />
          we change <br />
          we digitize
        </h1>
      </div>
    </div>
  </section>

  <section class="intro-section">
    <div class="intro-section__content">
      <h4 data-aos="fade-in" data-aos-delay="300">
        Our focus areas include the United Arab Emirates, Saudi Arabia, Qatar,
        Oman, Egypt, Singapore, Malaysia, and Indonesia. Through our
        professional approach and commitment to excellence, we provide
        comprehensive services and solutions in these strategic locations.
      </h4>
    </div>
  </section>

  <section class="who-we-are-section">
    <div class="wrapper">
      <div class="wrapper-right">
        <div class="title-position">
          <h4 data-aos="fade-in" data-aos-delay="300">
            <u> who </u>
            we are
          </h4>
        </div>
      </div>

      <div class="wrapper-left">
        <h3 data-aos="fade-in" data-aos-delay="300">
          Marihub was founded in 2019 by a team of industry experts who possess
          a deep understanding of the ins and outs of the maritime industry.
        </h3>
        <h3 data-aos="fade-in" data-aos-delay="300">
          The mission is to combine and connect the maritime industry segments
          into a single platform, saving time, money and facilitating business
          deals.
        </h3>
        <h3 data-aos="fade-in" data-aos-delay="300">
          The vision is to be the world’s leading maritime business hub and
          procurement marketplace serving marine industry
        </h3>
      </div>
    </div>
  </section>

  <section class="trusted-allies-section">
    <div data-aos="fade-in" data-aos-delay="300">
      <h1>Our trusted allies​​​</h1>
      <swiper class="swiper-wrapper" [config]="allies">
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/alianz-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/acta-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/sm-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/atlas-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/mcs-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/connect-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/ofco-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/marcap-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/kanoo-logo.png"
            class="swiper-image"
          />
        </ng-template>
        <ng-template swiperSlide>
          <img
            src="../../../../../assets/Images/allies/indogulf-logo.png"
            class="swiper-image"
          />
        </ng-template>
      </swiper>
    </div>
  </section>
  <!-- <section class="team-section">
    <div data-aos="fade-in" data-aos-delay="300">
      <h1>Meet our team</h1>
      <swiper [config]="team">
        <ng-template swiperSlide *ngFor="let member of teamData">
          <div class="team-section__item">
            <img
              src=""
              src="{{
                '../../../../../assets/Images/team/' + member.id + '.png'
              }}"
              class="team-section__item--pic"
            />

            <div class="title">
              <div class="title__name">{{ member.name }}</div>
              <div class="title__position">{{ member.position }}</div>
            </div>
          </div>
        </ng-template>
      </swiper>
    </div>
  </section> -->
</main>
<app-footer-v2></app-footer-v2>
